export default __webpack_public_path__ + "static/media/SadHeart.f8338e91.png";